import { useState } from 'react';
import { type Site, errText, flag, pickSite, post, siteApi } from './common';

type Act = 'start' | 'stop' | 'restart' | 'maintenance';
const ACTS: { key: Exclude<Act, 'maintenance'>; ic: string; label: string; short: string; title: string }[] = [
  { key: 'start', ic: '▶', label: 'Indítás', short: 'Indít', title: 'A weboldal indítása' },
  { key: 'stop', ic: '■', label: 'Leállítás', short: 'Leállít', title: 'A weboldal leállítása (a látogatók hibát kapnak)' },
  { key: 'restart', ic: '⟳', label: 'Újraindítás', short: 'Újra', title: 'Újraindítás, utána health-ellenőrzés' },
];

// A négy vezérlő gomb (kártyán és a részlet fejlécében): Indítás / Leállítás / Újraindítás / Karbantartás-kapcsoló.
// Hiba esetén nem alert: az onError a kártyán / fejlécben írja ki röviden.
export function SiteActions({ site, onDone, onError }: { site: Site; onDone: (fresh: Site | null) => void; onError: (msg: string) => void }) {
  const [busy, setBusy] = useState<Act | null>(null);
  const maint = flag(site.maintenance);
  const running = site.live?.running;

  const run = async (act: Act) => {
    if (busy) return;
    if (act === 'stop' && !confirm(`Leállítod: ${site.title || site.name}? A látogatók addig hibát kapnak.`)) return;
    setBusy(act); onError('');
    try {
      const r = await siteApi<unknown>(site.id, `/${act}`, post(act === 'maintenance' ? { on: !maint, text: site.maintenance_text ?? '' } : undefined));
      onDone(pickSite(r));
    } catch (e) {
      const what = act === 'maintenance' ? (maint ? 'Karbantartás kikapcsolása' : 'Karbantartás bekapcsolása') : ACTS.find((a) => a.key === act)?.label ?? act;
      onError(errText(e, what));
    } finally { setBusy(null); }
  };

  return (
    <div className="a-site-acts" onClick={(e) => e.stopPropagation()} onKeyDown={(e) => e.stopPropagation()}>
      {ACTS.map((a) => (
        <button key={a.key} type="button" className={`a-btn sm a-site-act ${a.key === 'start' && running === false ? 'pri' : ''}`} title={a.title}
          disabled={busy != null || (a.key === 'start' && running === true) || (a.key === 'stop' && running === false)} onClick={() => void run(a.key)}>
          <span className={`ic ${busy === a.key ? 'a-spin' : ''}`} aria-hidden="true">{busy === a.key ? '⟳' : a.ic}</span><span className="lb">{a.label}</span><span className="sh">{a.short}</span>
        </button>
      ))}
      <button type="button" role="switch" aria-checked={maint} className={`a-site-sw ${maint ? 'on' : ''}`} disabled={busy != null} onClick={() => void run('maintenance')}
        title={maint ? 'Karbantartás BE: minden kérésre 503 + karbantartás-oldal. Kattints a kikapcsoláshoz.' : 'Karbantartás bekapcsolása: a látogatók a karbantartás-oldalt kapják (503).'}>
        <span className="knob" aria-hidden="true"><i /></span><span className="lb">{busy === 'maintenance' ? 'Váltás…' : 'Karbantartás'}</span><span className="sh">Karb.</span>
      </button>
    </div>
  );
}
